"use client";

import React from "react";
import { Calendar, ShieldCheck, CircleCheck, Heart } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const trustFeatures = [{
  icon: Calendar,
  stat: "20+ Years",
  description: "Of dedicated experience in residential remodeling, delivering unwavering quality and craftsmanship to our community."
}, {
  icon: ShieldCheck,
  stat: "Licensed & Insured",
  description: "Fully credentialed professionals providing complete peace of mind and protection for your home investment."
}, {
  icon: CircleCheck,
  stat: "200+ Projects",
  description: "Successfully completed across Hudson, River Falls, Prescott, and Ellsworth with a focus on lasting satisfaction."
}, {
  icon: Heart,
  stat: "Faith & Family",
  description: "Guided by strong faith-based values, honesty, and a commitment to treating every client like family."
}];
export default function WhyNeighborsTrustFinelyDone() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="why-neighbors-trust-finely-done" className="dark bg-background text-foreground py-20 md:py-32 border-y border-border/20">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24">
          <h2 className="text-3xl md:text-4xl font-serif font-medium tracking-tight mb-4">
            Why Neighbors Trust Finely Done
          </h2>
          <div className="w-12 h-1 bg-accent mx-auto rounded-full opacity-80"></div>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {trustFeatures.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} className="flex flex-col items-center text-center group">
                <div className="mb-6 p-4 rounded-full bg-secondary/10 text-accent group-hover:bg-accent group-hover:text-accent-foreground transition-colors duration-300">
                  <Icon className="w-8 h-8 stroke-[1.5]" />
                </div>
                <h3 className="text-3xl font-light tracking-tight mb-4 text-foreground">
                  {feature.stat}
                </h3>
                <p className="text-muted-foreground font-sans text-base leading-relaxed max-w-[280px]">
                  {feature.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}